import { userRoles } from 'src/services/constants';

export default () => {
  let usersReadyResolve;
  const usersReady = new Promise((resolve) => {
    usersReadyResolve = resolve;
  });

  return {
    invite: null,
    users: {},
    usersLoading: false,
    usersReady,
    userBeingEdited: {
      firstName: '',
      lastName: '',
      accountRole: userRoles.VIEWER,
      email: '',
      smsPhoneNumber: '',
      appIds: [],
      groups: [],
      groupKeys: [],
      tags: [],
      tagKeys: [],
      emailNotification: true,
      pushNotification: true,
      tripEvents: 'none',
      locationEvents: false,
      preferredLocale: null,
      vehicleLocationEvents: 'all',
      lowFuelEvents: 'all',
      vehicleMaintenanceEvents: 'all',
      vehicleHealthEvents: true,
      vehicleScheduleEvents: 'all',
      hardBrakingEvents: true,
      crashEvents: true,
      overSpeedEvents: true,
      deviceEvents: true,
      marketingOptOut: false,
      bulletingFrequency: '',
      idleEvents: false,
    },
    extendedUserDetails: null,
    usersError: {},
    usersErrorMessage: null,
    changePasswordError: false,
    savingUser: false,
    alertSuggestions: {},
    usersReadyResolve,
  };
};
